
import arrow from '../assets/arrow.svg';
import calendarneon from '../assets/calendarneon.svg';
import locationneon from '../assets/locationneon.svg';
import music from '../assets/music.svg';
import neonsearch from '../assets/neonsearch.svg';
import neonstar from '../assets/neonstar.svg';
import neonticket from '../assets/neonticket.svg';
import person1 from '../assets/person1.png';
import person2 from '../assets/person2.png';
import person3 from '../assets/person3.png';
import tech from '../assets/tech.svg';
import theater from '../assets/theater.svg';
import ticket from '../assets/ticket.svg';
import volunteering from '../assets/volunteering.svg';
import workshops from '../assets/workshops.svg';
import Button from '../components/button';
import Categorybutton from '../components/categorybutton';
import Communitycard from '../components/communitycard';
import Eventcard from '../components/eventcard';
import Footer from '../components/footer';
import Header from '../components/header';
import Hero from '../components/hero';
import Howitworkscard from '../components/howitworkscard';
import Sectiontitle from '../components/sectiontitle';
import Stickerlabel from '../components/stickerlabel';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { supabase } from '../supabase';

import './home.css';

const Home = () => {
  const { t, i18n } = useTranslation();
  const isAr = i18n.language?.startsWith('ar');
  const [events, setEvents] = useState([]);
  const [featuredEvent, setFeaturedEvent] = useState(null);

  useEffect(() => {
    const getAllEvents = async () => {
      const res = await supabase
        .from('Events')
        .select(`
          *,
          Categories(name, name_ar),
          Locations(venue_name, venue_name_ar, city, city_ar)
        `);

      setEvents(res.data || []);
    };

    const getFeaturedEvent = async () => {
      const res = await supabase
        .from('Events')
        .select(`
          *,
          Locations(venue_name, venue_name_ar, city, city_ar)
        `)
        .eq('title', 'Future Tech Summit 2026')
        .single();

      setFeaturedEvent(res.data || null);
    };

    getAllEvents();
    getFeaturedEvent();
  }, []);

  const featuredTitle = isAr ? (featuredEvent?.title_ar || featuredEvent?.title) : featuredEvent?.title;
  const featuredTitleParts = featuredTitle?.split(' ') || [];
  const featuredTitleFirst = featuredTitleParts[0] || '';
  const featuredTitleMiddle = featuredTitleParts.slice(1, -1).join(' ');
  const featuredTitleLast = featuredTitleParts[featuredTitleParts.length - 1] || '';

  return (
    <>
      <Header />
      <Hero />

      <section id='events' className='events'>
        <div className='categories'>
          <Categorybutton categorystyle="category_button category_button_active" categorytext={t('events.all')} categoryimg={music} />
          <Categorybutton categorystyle="category_button" categorytext={t('events.music')} categoryimg={music} />
          <Categorybutton categorystyle="category_button" categorytext={t('events.theatre')} categoryimg={theater} />
          <Categorybutton categorystyle="category_button" categorytext={t('events.workshops')} categoryimg={workshops} />
          <Categorybutton categorystyle="category_button" categorytext={t('events.tech_talks')} categoryimg={tech} />
          <Categorybutton categorystyle="category_button" categorytext={t('events.volunteering')} categoryimg={volunteering} />
        </div>
        <div className='events_section'>
          <div className='events_title'>
            <div className='events_title_copy'>
              <Sectiontitle titlegreen={t('events.title_green')} titleorange={t('events.title_orange')} />
              <div className='events_title_subtitle'>{t('events.subtitle')}</div>
            </div>
            <div className='events_title_link'>
              <div>{t('events.view_all')}</div>
              <svg className='events_title_arrow' viewBox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg'>
                <path d='M3 9H15' stroke='currentColor' strokeWidth='1.8' strokeLinecap='round' />
                <path d='M10.5 4.5L15 9L10.5 13.5' stroke='currentColor' strokeWidth='1.8' strokeLinecap='round' strokeLinejoin='round' />
              </svg>
            </div>
          </div>
          <div className='events_cards'>
            {events.map((event) => (
              <Eventcard
                key={event.id}
                cardstyle="event_card"
                cardimg={event.image_url}
                cardcategory={isAr ? (event.Categories?.name_ar || event.Categories?.name) : event.Categories?.name}
                cardlimit={event.show_tickets_left ? `${event.tickets_left} ${t('events.left')}` : ''}
                cardbadge={event.is_popular ? t('events.popular') : ''}
                cardtitle={isAr ? (event.title_ar || event.title) : event.title}
                carddate={event.date}
                cardlocation={isAr ? (event.Locations?.venue_name_ar || event.Locations?.venue_name) : event.Locations?.venue_name}
                buttonstyle="event_card_button"
                buttontext={t('events.book_ticket')}
              />
            ))}
          </div>
          
        </div>
      </section>

      <section id='how-it-works' className='how_it_works_section'>
        <div className='how_it_works'>
          <div className='how_it_works_title'>
            <Sectiontitle titlegreen={t('how_it_works.title_green')} titleorange={t('how_it_works.title_orange')} />
            <div className='how_it_works_subtitle'>{t('how_it_works.subtitle')}</div>
          </div>
          <div className='how_it_works_cards'>
            <Howitworkscard cardstyle="how_it_works_card how_it_works_card_1" cardimg={neonsearch} cardnumber="1" cardtitle={t('how_it_works.card1_title')} cardtext={t('how_it_works.card1_text')} />
            <Howitworkscard cardstyle="how_it_works_card how_it_works_card_2" cardimg={neonticket} cardnumber="2" cardtitle={t('how_it_works.card2_title')} cardtext={t('how_it_works.card2_text')} />
            <Howitworkscard cardstyle="how_it_works_card how_it_works_card_3" cardimg={neonstar} cardnumber="3" cardtitle={t('how_it_works.card3_title')} cardtext={t('how_it_works.card3_text')} />
          </div>
        </div>
      </section>

      {featuredEvent && (
        <section id='featured' className='featured_event_section'>
          <div className='featured_event'>
            <div className='featured_event_image'>
              <div className='featured_event_badge'>{t('featured_event.badge')}</div>
              <img src={featuredEvent.image_url} alt={featuredEvent.title} />
            </div>
            <div className='featured_event_content'>
              <div className='featured_event_title'>
                <div className='featured_event_title_row'>
                  <div>{featuredTitleFirst}</div>
                  {featuredTitleMiddle && <div className='featured_event_title_neon'>{featuredTitleMiddle}</div>}
                </div>
                {featuredTitleLast && <div>{featuredTitleLast}</div>}
              </div>
              <div className='featured_event_text'>
                {isAr ? (featuredEvent.description_ar || featuredEvent.description) : featuredEvent.description}
              </div>
              <div className='featured_event_meta'>
                <div className='featured_event_meta_item'>
                  <img src={calendarneon} alt="" />
                  <div className='featured_event_meta_copy'>
                    <div className='featured_event_meta_title'>{featuredEvent.date}</div>
                    <div className='featured_event_meta_text'>{featuredEvent.start_time}</div>
                  </div>
                </div>
                <div className='featured_event_meta_item'>
                  <img src={locationneon} alt="" />
                  <div className='featured_event_meta_copy'>
                    <div className='featured_event_meta_title'>{isAr ? (featuredEvent.Locations?.venue_name_ar || featuredEvent.Locations?.venue_name) : featuredEvent.Locations?.venue_name}</div>
                    <div className='featured_event_meta_text'>{isAr ? (featuredEvent.Locations?.city_ar || featuredEvent.Locations?.city) : featuredEvent.Locations?.city}</div>
                  </div>
                </div>
              </div>
              <div className='featured_event_starts'>{t('featured_event.starts_in')}</div>
              <div className='featured_event_timer'>
                <div className='featured_event_timer_box'>
                  <div className='featured_event_timer_number'>24</div>
                  <div className='featured_event_timer_label'>Days</div>
                </div>
                <div className='featured_event_timer_box'>
                  <div className='featured_event_timer_number'>12</div>
                  <div className='featured_event_timer_label'>Hours</div>
                </div>
                <div className='featured_event_timer_box'>
                  <div className='featured_event_timer_number'>45</div>
                  <div className='featured_event_timer_label'>Mins</div>
                </div>
                <div className='featured_event_timer_box'>
                  <div className='featured_event_timer_number'>30</div>
                  <div className='featured_event_timer_label'>Secs</div>
                </div>
              </div>
              <Button btnstyle="btnstyle1 featured_event_button" btntext={t('featured_event.button')} />
            </div>
          </div>
        </section>
      )}

      <section id='booking' className='booking_section'>
        <div className='booking_section_inner'>
          <Stickerlabel labelstyle="booking_section_label booking_section_label_left" labeltext={t('booking.left_label')} />
          <div className='booking_form_panel'>
            <div className='booking_form_title'>
              <Sectiontitle titlegreen={t('booking.title_green')} titleorange={t('booking.title_orange')} />
            </div>
            <div className='booking_form_subtitle'>{t('booking.subtitle')}</div>
            <div className='booking_form_grid'>
              <div className='booking_input_group'>
                <div className='booking_input_label'>{t('booking.name_label')}</div>
                <input className='booking_input' type='text' placeholder={t('booking.name_placeholder')} />
              </div>
              <div className='booking_input_group'>
                <div className='booking_input_label'>{t('booking.email_label')}</div>
                <input className='booking_input' type='email' placeholder={t('booking.email_placeholder')} />
              </div>
              <div className='booking_input_group booking_input_group_full'>
                <div className='booking_input_label'>{t('booking.event_label')}</div>
                <select className='booking_input booking_select' defaultValue=''>
                  <option value='' disabled>{t('booking.event_placeholder')}</option>
                  <option value='event_1'>{t('booking.event_1')}</option>
                  <option value='event_2'>{t('booking.event_2')}</option>
                  <option value='event_3'>{t('booking.event_3')}</option>
                  <option value='event_4'>{t('booking.event_4')}</option>
                </select>
              </div>
              <div className='booking_input_group booking_input_group_full'>
                <div className='booking_input_label'>{t('booking.tickets_label')}</div>
                <select className='booking_input booking_select' defaultValue='ticket_1'>
                  <option value='ticket_1'>{t('booking.ticket_1')}</option>
                  <option value='ticket_2'>{t('booking.ticket_2')}</option>
                  <option value='ticket_3'>{t('booking.ticket_3')}</option>
                  <option value='ticket_4'>{t('booking.ticket_4')}</option>
                </select>
              </div>
            </div>
            <Button btnstyle="booking_button" btntext={t('booking.button')} btnimg={ticket} />
          </div>
          <Stickerlabel labelstyle="booking_section_label booking_section_label_right" labeltext={t('booking.right_label')} />
        </div>
      </section>

      <section id='community' className='community_section'>
        <div className='community_section_inner'>
          <div className='community_title'>
            <div className='community_title_main'>{t('community.title_main')}</div>
            <div className='community_title_sub'>{t('community.title_sub')}</div>
          </div>

          <div className='community_cards'>
            <Communitycard cardstyle="community_card community_card_left" cardimg={person2} cardname={t('community.card1_name')} cardrole={t('community.card1_role')} cardtext={t('community.card1_text')} cardstars="★★★★★" cardtag1={t('community.card1_tag1')} cardtag2={t('community.card1_tag2')} />
            <Communitycard cardstyle="community_card community_card_center" cardimg={person1} cardname={t('community.card2_name')} cardrole={t('community.card2_role')} cardtext={t('community.card2_text')} cardstars="★★★★★" cardtag1={t('community.card2_tag1')} cardtag2={t('community.card2_tag2')} />
            <Communitycard cardstyle="community_card community_card_right" cardimg={person3} cardname={t('community.card3_name')} cardrole={t('community.card3_role')} cardtext={t('community.card3_text')} cardstars="★★★★★" cardtag1={t('community.card3_tag1')} cardtag2={t('community.card3_tag2')} />
          </div>
        </div>
      </section>

      <section id='newsletter' className='newsletter_section'>
        <div className='newsletter_section_inner'>
          <Stickerlabel labelstyle="newsletter_label newsletter_label_left" labeltext={t('newsletter.left_label')} />
          <Stickerlabel labelstyle="newsletter_label newsletter_label_right" labeltext={t('newsletter.right_label')} />

          <div className='newsletter_title'>{t('newsletter.title')}</div>
          <div className='newsletter_subtitle'>{t('newsletter.subtitle')}</div>
          <div className='newsletter_text'>
            {t('newsletter.text')}
          </div>

          <div className='newsletter_form'>
            <input className='newsletter_input' type='email' placeholder={t('newsletter.placeholder')} />
            <Button btnstyle="newsletter_button" btntext={t('newsletter.button')} btnimg={arrow} />
          </div>

          <div className='newsletter_points'>
            <div className='newsletter_point'>
              <svg className='newsletter_point_mark' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
                <path d='M3 8L6.2 11.2L13 4.4' stroke='currentColor' strokeWidth='1.8' strokeLinecap='round' strokeLinejoin='round' />
              </svg>
              <div>{t('newsletter.point_1')}</div>
            </div>
            <div className='newsletter_point'>
              <svg className='newsletter_point_mark' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
                <path d='M3 8L6.2 11.2L13 4.4' stroke='currentColor' strokeWidth='1.8' strokeLinecap='round' strokeLinejoin='round' />
              </svg>
              <div>{t('newsletter.point_2')}</div>
            </div>
            <div className='newsletter_point'>
              <svg className='newsletter_point_mark' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
                <path d='M3 8L6.2 11.2L13 4.4' stroke='currentColor' strokeWidth='1.8' strokeLinecap='round' strokeLinejoin='round' />
              </svg>
              <div>{t('newsletter.point_3')}</div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default Home;
